import WheelPicker from '../WheelPicker';
import styles from './styles.module.scss';

/**
 * Three-column hour / minute / AM-PM wheel.
 *
 * Extracted from Profile v2 `EditBirthTime` (HORO-10360) so the Birth Chart
 * flow's time sheet shares one picker with the profile editor.
 *
 * Controlled: the caller owns `{ hour (1-12), minute (0-59), meridiem }`.
 */
export const HOURS = Array.from({ length: 12 }, (_, i) => i + 1);
export const MINUTES = Array.from({ length: 60 }, (_, i) => i);
export const MERIDIEM = ['AM', 'PM'];

const pad = (n) => String(n).padStart(2, '0');

const DEFAULT_LABELS = { hour: 'Hour', minute: 'Minute', meridiem: 'AM or PM' };

const BirthTimePicker = ({ hour, minute, meridiem, onHourChange, onMinuteChange, onMeridiemChange, labels = DEFAULT_LABELS }) => (
    <div className={styles.wheels}>
        <WheelPicker items={HOURS} value={hour} onChange={onHourChange} ariaLabel={labels.hour} />
        <WheelPicker items={MINUTES} value={minute} onChange={onMinuteChange} format={pad} ariaLabel={labels.minute} />
        <WheelPicker items={MERIDIEM} value={meridiem} onChange={onMeridiemChange} ariaLabel={labels.meridiem} />
    </div>
);

export default BirthTimePicker;
